import { useState, useRef, useEffect } from "react";
import styles from "./FilterBar.module.css";

import dropMenu from "../../assets/svgs/dropMenu.svg";
import dropMenuHover from "../../assets/svgs/dropMenuHover.svg";
import dropMenuSelected from "../../assets/svgs/dropMenuSelected.svg";
import arrowDown from "../../assets/svgs/grey_menu_arrow.svg";
import arrowDownHover from "../../assets/svgs/arrow-down-hover.svg";
import arrowDownSelected from "../../assets/svgs/arrow-down-selected.svg";
import departmentIcon from "../../assets/svgs/department.svg";
import departmentIconHover from "../../assets/svgs/departmentHover.svg";
import departmentIconSelected from "../../assets/svgs/departmentSelected.svg";
import checkmark from "../../assets/svgs/checkmark.svg";
import searchIcon from "../../assets/svgs/search.svg";
import closeIcon from "../../assets/svgs/close.svg";
import exitIcon from "../../assets/svgs/exit_icon.svg";
import exitIconHover from "../../assets/svgs/exit_icon_hover.svg";

const FilterBar = ({ orderOption, onOrderChange, users, onFilteredUsersChange, isMobile, initialDepartment, }) => {
  const [searchText, setSearchText] = useState("");
  const [showOrderDropdown, setShowOrderDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isDeptHovered, setIsDeptHovered] = useState(false);;
  const [showDeptDropdown, setShowDeptDropdown] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(
    initialDepartment || "Comunicación"
  );
  const [isExitHovered, setIsExitHovered] = useState(false);
  const dropdownRef = useRef(null);
  const deptDropdownRef = useRef(null);

  const normalizeText = (text) =>
    text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOrderDropdown(false);
      }
      if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
        setShowDeptDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!showOrderDropdown) {
      setIsHovered(false);
    }
    if (!showDeptDropdown) {
      setIsDeptHovered(false);
    }
  }, [showOrderDropdown, showDeptDropdown]);

  useEffect(() => {
    if (initialDepartment) {
      setSelectedDepartment(initialDepartment);
    }
  }, [initialDepartment]);

  useEffect(() => {
    if (users && Array.isArray(users)) {
      const filtered = users.filter((user) => {
        const matchName = normalizeText(user.Nombre).includes(normalizeText(searchText));
        const matchDept = selectedDepartment
          ? user.Departamentos?.includes(selectedDepartment)
          : true;
        return matchName && matchDept;
      });
      onFilteredUsersChange(filtered);
    }
  }, [searchText, users, selectedDepartment, onFilteredUsersChange]);

  const toggleOrderDropdown = () => {
    setShowOrderDropdown((prev) => !prev);
  };

  const handleSelectOrder = (value) => {
    onOrderChange(value);
    setShowOrderDropdown(false);
  };

  const handleSelectDepartment = (dept) => {
    setSelectedDepartment(dept);
    setShowDeptDropdown(false);
  };

  const orderLabels = {
    priority: "Prioridad",
    maxLoad: "Mayor carga",
    minLoad: "Menor carga",
    alphabetical: "Alfabético",
    notesCount: "Nº comentarios",
  };

  const allDepartments = ["Comunicación", "Informática", "Diseño", "Administración"];

  const currentLabel = orderLabels[orderOption] || "Prioridad";

  let leftIcon = dropMenu;
  let rightIcon = arrowDown;
  if (showOrderDropdown) {
    leftIcon = dropMenuSelected;
    rightIcon = arrowDownSelected;
  } else if (isHovered) {
    leftIcon = dropMenuHover;
    rightIcon = arrowDownHover;
  }

  return (
    <div className={`${styles.filterBar} ${isMobile ? styles.filterBarMobile : ""}`}>

      <div className={`${isMobile ? styles.searchInputWrapperMobile : styles.searchInputWrapper}`}>
        <img
          src={searchIcon}
          alt="Buscar"
          className={isMobile ? styles.searchIconMobile : styles.searchIcon}
        />
        <input
          type="text"
          placeholder="Buscar..."
          className={`${styles.searchInput} ${isMobile ? styles.searchInputMobile : ""}`}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        {searchText && (
          <button
            type="button"
            className={`${styles.clearButton} ${isMobile ? styles.clearButtonMobile : ""}`}
            onClick={() => setSearchText("")}
          >
            <img
              src={closeIcon}
              alt="Limpiar búsqueda"
              className={`${styles.clearIcon} ${isMobile ? styles.clearIconMobile : ""}`}
            />
          </button>
        )}
      </div>

      {isMobile ? (
        <div className={styles.mobileColumn}>
          <div className={styles.mobileDropdownsRow}>
            <div className={styles.orderDropdownWrapperMobile} ref={deptDropdownRef}>
              <button
                className={`${styles.orderButton} ${showDeptDropdown ? styles.active : ""}`}
                onClick={() => setShowDeptDropdown((prev) => !prev)}
                onMouseEnter={() => setIsDeptHovered(true)}
                onMouseLeave={() => setIsDeptHovered(false)}
              >
                <img
                  src={
                    showDeptDropdown
                      ? departmentIconSelected
                      : isDeptHovered
                        ? departmentIconHover
                        : departmentIcon
                  }
                  alt="Dept"
                />
                <span>{selectedDepartment || "Departamentos"}</span>
                <img
                  src={
                    showDeptDropdown
                      ? arrowDownSelected
                      : isDeptHovered
                        ? arrowDownHover
                        : arrowDown
                  }
                  alt="Expandir"
                />
              </button>
              {showDeptDropdown && (
                <div className={styles.orderDropdownMenu}>
                  {allDepartments.map((dept) => (
                    <div
                      key={dept}
                      className={`${styles.orderDropdownMenuItem} ${selectedDepartment === dept ? styles.selectedItem : ""
                        }`}
                      onClick={() => handleSelectDepartment(dept)}
                    >
                      <span>{dept}</span>
                      {selectedDepartment === dept && (
                        <img src={checkmark} alt="Seleccionado" className={styles.checkIcon} />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className={styles.orderDropdownWrapperMobile} ref={dropdownRef}>
              <button
                className={`${styles.orderButton} ${showOrderDropdown ? styles.active : ""}`}
                onClick={toggleOrderDropdown}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img src={leftIcon} alt="Icono menú" />
                <span>{currentLabel}</span>
                <img src={rightIcon} alt="Desplegar" />
              </button>

              {showOrderDropdown && (
                <div className={styles.orderDropdownMenu}>
                  {Object.entries(orderLabels).map(([key, label]) => (
                    <div
                      key={key}
                      className={`${styles.orderDropdownMenuItem} ${orderOption === key ? styles.selectedItem : ""}`}
                      onClick={() => handleSelectOrder(key)}
                    >
                      <span>{label}</span>
                      {orderOption === key && (
                        <img src={checkmark} alt="Check" className={styles.checkIcon} />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className={styles.mobileBelowRow}>
            <a
              href="/admin/salidas"
              className={`${styles.orderButton} ${styles.noUnderline}`}
              onMouseEnter={() => setIsExitHovered(true)}
              onMouseLeave={() => setIsExitHovered(false)}
            >
              <span>Salidas equipo</span>
              <img
                src={isExitHovered ? exitIconHover : exitIcon}
                alt="Salidas equipo"
                className={styles.exitIcon}
              />
            </a>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.orderDropdownWrapper} ref={deptDropdownRef}>
            <button
              className={`${styles.orderButton} ${showDeptDropdown ? styles.active : ""}`}
              onClick={() => setShowDeptDropdown((prev) => !prev)}
              onMouseEnter={() => setIsDeptHovered(true)}
              onMouseLeave={() => setIsDeptHovered(false)}
            >
              <img
                src={
                  showDeptDropdown
                    ? departmentIconSelected
                    : isDeptHovered
                      ? departmentIconHover
                      : departmentIcon
                }
                alt="Dept"
              />
              <span>{selectedDepartment || "Departamentos"}</span>
              <img
                src={
                  showDeptDropdown
                    ? arrowDownSelected
                    : isDeptHovered
                      ? arrowDownHover
                      : arrowDown
                }
                alt="Expandir"
              />
            </button>
            {showDeptDropdown && (
              <div className={styles.orderDropdownMenu}>
                {allDepartments.map((dept) => (
                  <div
                    key={dept}
                    className={`${styles.orderDropdownMenuItem} ${selectedDepartment === dept ? styles.selectedItem : ""}`}
                    onClick={() => handleSelectDepartment(dept)}
                  >
                    <span>{dept}</span>
                    {selectedDepartment === dept && (
                      <img src={checkmark} alt="Seleccionado" className={styles.checkIcon} />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.orderDropdownWrapper} ref={dropdownRef}>
            <button
              className={`${styles.orderButton} ${showOrderDropdown ? styles.active : ""}`}
              onClick={toggleOrderDropdown}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <img src={leftIcon} alt="Icono menú" />
              <span>{currentLabel}</span>
              <img src={rightIcon} alt="Desplegar" />
            </button>

            {showOrderDropdown && (
              <div className={styles.orderDropdownMenu}>
                {Object.entries(orderLabels).map(([key, label]) => (
                  <div
                    key={key}
                    className={`${styles.orderDropdownMenuItem} ${orderOption === key ? styles.selectedItem : ""}`}
                    onClick={() => handleSelectOrder(key)}
                  >
                    <span>{label}</span>
                    {orderOption === key && (
                      <img src={checkmark} alt="Check" className={styles.checkIcon} />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.orderDropdownWrapper}>
            <a
              href="/admin/salidas"
              className={styles.orderButton}
              style={{ textDecoration: "none" }}
              onMouseEnter={() => setIsExitHovered(true)}
              onMouseLeave={() => setIsExitHovered(false)}
            >
              <span>Salidas equipo</span>
              <img
                src={isExitHovered ? exitIconHover : exitIcon}
                alt="Salidas equipo"
                className={styles.exitIcon}
              />
            </a>
          </div>
        </>
      )}

    </div>
  );
};

export default FilterBar;
